import apiClient from '../config/axios';

// Auth API
export const authAPI = {
  login: async (supabaseToken) => {
    const response = await apiClient.post('/auth/login', { supabase_token: supabaseToken });
    return response.data;
  },
  
  refresh: async (refreshToken) => {
    const response = await apiClient.post('/auth/refresh', { refresh_token: refreshToken });
    return response.data;
  },
  
  getProfile: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },
  
  logout: async () => {
    const response = await apiClient.post('/auth/logout');
    return response.data;
  }
};

// Database API with authentication
export const databaseAPI = {
  connect: async (dbType, connectionParams) => {
    const response = await apiClient.post('/secure/database/connect', {
      db_type: dbType,
      connection_params: connectionParams
    });
    return response.data;
  },
  
  list: async () => {
    const response = await apiClient.get('/secure/database/list');
    return response.data;
  },
  
  getSchema: async (databaseId) => {
    const response = await apiClient.get(`/secure/database/${databaseId}/schema`);
    return response.data;
  },
  
  disconnect: async (databaseId) => {
    const response = await apiClient.post(`/secure/database/${databaseId}/disconnect`);
    return response.data;
  },
  
  getQueryHistory: async (databaseId = null, limit = 50) => {
    const params = new URLSearchParams();
    if (databaseId) params.append('database_id', databaseId);
    params.append('limit', limit);
    
    const response = await apiClient.get(`/secure/database/query-history?${params}`);
    return response.data;
  }
};

// Query API with authentication
export const queryAPI = {
  generate: async (query, databaseId, modelName) => {
    const response = await apiClient.post('/secure/database/query/generate', {
      query: query,
      database_id: databaseId,
      model_name: modelName
    });
    return response.data;
  },
  
  execute: async (query, databaseId) => {
    const response = await apiClient.post('/secure/database/query/execute', {
      query: query,
      database_id: databaseId
    });
    return response.data;
  },
  
  suggest: async (databaseId, prompt) => {
    const response = await apiClient.post('/api/v2/query/suggest', {
      database_id: databaseId,
      prompt: prompt
    });
    return response.data;
  }
};

// Model API
export const modelAPI = {
  list: async () => {
    const response = await apiClient.get('/model/list');
    return response.data;
  },
  
  select: async (modelName) => {
    const response = await apiClient.post('/model/select', {
      model_name: modelName
    });
    return response.data;
  },
  
  getCurrent: async () => {
    const response = await apiClient.get('/model/current');
    return response.data;
  }
};